module.exports = __webpack_public_path__ + "static/media/RafaelBonavita.eb7d925d.jpg";